import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class CategoriasAmazonService extends ApiService {
  entityType = EntityType.AMAZON_CATEGORIA;
  url = 'api/marketplace/amazon/categorias/';
}
